import { render } from "./WorldwideTopCreators.vue?vue&type=template&id=b951a3d0&ts=true"
import script from "./WorldwideTopCreators.vue?vue&type=script&lang=ts"
export * from "./WorldwideTopCreators.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__